import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";
import Seo from "@/components/feature/Seo";
import FeedbackForm from "@/pages/about/components/FeedbackForm";

const notices = [
  {
    icon: "ri-information-line",
    title: "内容说明",
    text: "本站为演示性质的视频内容聚合与资源导航站，所有视频条目、封面与信息均为演示内容，不提供真实播放或下载服务。",
  },
  {
    icon: "ri-shield-check-line",
    title: "使用须知",
    text: "资源导航按钮仅指向外部平台的跳转指示，请通过正规渠道获取相关资源，并遵守当地法律法规与平台规范。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权声明",
    text: "本站展示的视频标题、分类与简介信息仅用于内容聚合与导航展示，相关权利归原始权利人所有，如有异议可通过反馈表单联系我们。",
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于我们-黄瓜视频下载高清视频聚合平台"
        description="了解黄瓜视频下载的站点定位、内容范围与联系方式。本站专注高清视频内容聚合与资源导航，所有内容均为演示，仅用于展示结构与交互。"
        keywords="黄瓜视频下载,关于我们,视频聚合平台,资源导航,高清视频"
      />

      <div className="mx-auto w-full max-w-7xl px-4 pt-6 md:px-6 md:pt-8">
        <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 py-12 md:px-12 md:py-16">
          <div className="relative z-10 max-w-3xl">
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-white">
              <i className="ri-plant-line"></i>
              关于黄瓜视频下载
            </span>
            <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-4xl">
              高清视频内容聚合与资源导航
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
              我们把散落各处的视频条目集中整理，提供清晰的分类、筛选与检索体验，让查找高清视频资源变得更简单、更有条理。
            </p>
          </div>
          <span className="pointer-events-none absolute -right-6 top-1/2 hidden h-56 w-56 -translate-y-1/2 items-center justify-center rounded-full bg-primary-800/60 text-primary-700 md:flex">
            <i className="ri-plant-line text-8xl"></i>
          </span>
        </div>

        <section className="mt-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-focus-3-line text-xl"></i>
              </span>
              <h2 className="font-heading text-lg font-bold text-foreground-950">网站定位</h2>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              黄瓜视频下载是一个面向普通视频爱好者的高清视频内容聚合与资源导航平台。我们聚焦内容聚合与信息梳理，通过分类、筛选、排序与搜索等功能，帮助用户高效定位感兴趣的视频条目，并通过详情页了解其基本信息与资源流向。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-stack-line text-xl"></i>
              </span>
              <h2 className="font-heading text-lg font-bold text-foreground-950">内容范围</h2>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              目前覆盖 {categories.length} 大分类、共 {videos.length} 个演示视频条目，涵盖下列内容方向：
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {categories.map((category) => (
                <Link
                  key={category.id}
                  to={`/category/${category.id}`}
                  className="flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
                >
                  <i className={`${category.icon} text-sm text-primary-500`}></i>
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-6 flex items-center gap-3">
            <span className="h-6 w-1 rounded-full bg-primary-500"></span>
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">使用须知与版权声明</h2>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5">
            {notices.map((notice) => (
              <div key={notice.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className={`${notice.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{notice.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{notice.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <div className="mb-6 flex items-center gap-3">
            <span className="h-6 w-1 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">联系我们</h2>
          </div>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
            <div className="space-y-4 lg:col-span-2">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">邮箱联系</p>
                    <p className="font-heading text-sm font-semibold text-foreground-950">support@huanggua-video.com</p>
                  </div>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                  如需反馈内容建议、资源导航或版权相关事宜，欢迎通过邮箱联系我们，或直接使用右侧反馈表单提交。
                </p>
              </div>
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className="ri-question-answer-line text-lg"></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-500">在线反馈</p>
                    <p className="font-heading text-sm font-semibold text-foreground-950">填写表单，我们会尽快回复</p>
                  </div>
                </div>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                  我们通常在 2 个工作日内回复，请留下有效的邮箱地址以便我们与你取得联系。
                </p>
              </div>
            </div>
            <div className="lg:col-span-3">
              <FeedbackForm />
            </div>
          </div>
        </section>

        <section className="mt-12 mb-4 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 px-6 py-8 text-center md:flex-row md:text-left">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950">开始浏览高清视频资源</h2>
            <p className="mt-1 text-sm text-foreground-600">按分类、关键词快速查找你感兴趣的视频条目。</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览全部视频
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              返回首页
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}